import {
    commonNewClassnames
} from '@common';

const prefix = 'oauth';

export const newClassnames = (name) => commonNewClassnames(`${prefix}-${name}`);

export const routerPaths = {
    home: `/${prefix}/home/:active`,
    login: {
        loginStudentID: `/${prefix}/loginStudentID`,
        loginSingPass: `/${prefix}/loginSingPass`,
    },
    emailOTP: {
        index: `/${prefix}/emailOTP/`,
    },
    retrieve: {
        oprateStudentId: `/${prefix}/studentid/:way`,
        singpassRetrieve: `/${prefix}/retrieve/singpassway`,
        index: `/${prefix}/retrieve`,
    },
    privacyStatement: `/${prefix}/privacystatement`,
    termsOfUse: `/${prefix}/termsOfUse`,
    FAQ: `/${prefix}/FAQ`
};